import styled from 'styled-components';
import { useIntl } from 'react-intl';
import StatusPublished from '~/assets/icons/StatusPublished';
import StatusDraft from '~/assets/icons/StatusDraft';
import StatusPending from '~/assets/icons/StatusPending';
import StatusUnPublished from '~/assets/icons/StatusUnpublished';
import StatusInfected from '~/assets/icons/StatusInfected';

const StatusIconWrapper = styled.div`
  height: 30px;
  margin-top: 5px;
  margin-left: 5px;
  & svg {
    max-height: 100%;
    width: 100%;
    fill: ${({ status, theme }) => {
      if (status === 'PUBLISHED') {
        return theme.color.brandSuccess500;
      }
      if (status === 'PLANNED_FOR_PUBLISHING' || status === 'DRAFT') {
        return theme.color.cta;
      }
      return theme.color.brandDanger500;
    }};
  }
`;

/**
 * @typedef {Object} data
 * @property {React.ReactElement} statusIcon
 * @property {string} title
 */

/**
 * @param {Object} props
 * @param {import('react-intl').IntlShape} props.intl
 * @returns {Record<IconStatus, data>}
 */
const getStatusData = ({ intl }) => ({
  PUBLISHED: {
    statusIcon: <StatusPublished />,
    title: intl.formatMessage({ id: 'gijp.status.published' }),
  },
  PLANNED_FOR_PUBLISHING: {
    statusIcon: <StatusPending />,
    title: intl.formatMessage({ id: 'gijp.status.planned_for_publishing' }),
  },
  DRAFT: {
    statusIcon: <StatusDraft />,
    title: intl.formatMessage({ id: 'gijp.status.draft' }),
  },
  DRAFT_INCOMPLETE: {
    statusIcon: <StatusDraft />,
    title: intl.formatMessage({ id: 'gijp.status.draft_incomplete' }),
  },
  UNPUBLISHED: {
    statusIcon: <StatusUnPublished />,
    title: intl.formatMessage({ id: 'gijp.status.unpublished' }),
  },
  INFECTED: {
    statusIcon: <StatusInfected />,
    title: intl.formatMessage({ id: 'gijp.status.infected' }),
  },
});

/**
 * @param {Object} props
 * @param {IconStatus} props.status
 * @param {boolean} [props.withLabel=false]
 * @returns {React.ReactElement}
 */
const StatusIcon = ({ status, withLabel = false }) => {
  const { statusIcon, title } = getStatusData({ intl: useIntl() })[status];

  return (
    <StatusIconWrapper status={status} title={title}>
      <>
        {withLabel && <div>{title}</div>} {statusIcon}
      </>
    </StatusIconWrapper>
  );
};

export default StatusIcon;
